import { combineReducers, configureStore } from "@reduxjs/toolkit";
import type { Immutable } from "immer";
import React from "react";
import { Provider } from "react-redux";
import { Basket } from "tsi-common-react/src/apps/checkout/Basket/index";
import { defaults } from "tsi-common-react/src/apps/checkout/defaults";
import { reducers as checkoutReducers } from "tsi-common-react/src/apps/checkout/reducers";
import type { IBasket } from "tsi-common-react/src/models/catalogue";
import { reducers as commonReducers } from "tsi-common-react/src/store/common/reducers";

import { templates } from "@reactivated";

import { BasketWrapper } from "../components/BasketWrapper";
import { StyleguideChrome } from "../components/StyleguideChrome";

type IProps = Immutable<templates.StyleguideBasketElementTemplate>;

const BasketFixture = (props: { basketJson: string }): React.JSX.Element => {
    const store = React.useMemo(
        () =>
            configureStore({
                reducer: combineReducers({
                    checkout: checkoutReducers,
                    common: commonReducers,
                }),
                preloadedState: {
                    checkout: {
                        ...defaults,
                        data: {
                            ...defaults.data,
                            basket: JSON.parse(props.basketJson) as IBasket,
                        },
                    },
                },
            }),
        [props.basketJson],
    );
    return (
        <Provider store={store}>
            <BasketWrapper>
                <div id="basket-app">
                    <Basket
                        getLineProductUpsell={() => null}
                        showValueProps={true}
                        getExtraSummaryContent={() => null}
                        getExtraSidebarContent={() => null}
                        getExtraMainColumnContent={() => null}
                    />
                </div>
            </BasketWrapper>
        </Provider>
    );
};

export const Template = (props: IProps): React.JSX.Element => {
    const content = <BasketFixture basketJson={props.basket_json} />;
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? (
                content
            ) : (
                <div id="element-tester">{content}</div>
            )}
        </StyleguideChrome>
    );
};
